var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.4375 3.8125H15V0H11.9688C8.3125 0.15625 7.5625 2.21875 7.5 4.375V6.28125H5V10H7.5V20H11.25V10H14.3438L14.9375 6.28125H11.25V5.125C11.24 4.96044 11.2629 4.79553 11.3175 4.63995C11.372 4.48438 11.4571 4.34126 11.5677 4.21901C11.6783 4.09675 11.8122 3.99782 11.9616 3.92801C12.111 3.85821 12.2728 3.81894 12.4375 3.8125Z","fill":"#22202F"}));
}

SocialFacebook.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
